export default __webpack_public_path__ + "static/media/vox-img-legacy-006.eaa5702d.jpg";